import { ColorScheme } from '@mantine/core'

export const getSystemColorScheme = (): ColorScheme => {
  return window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light'
}
